export default __webpack_public_path__ + "static/media/788.dae99ef4.gif";